<template>
  <v-menu
    v-model="menuTree"
    transition="scale-transition"
    offset-y
    min-width="600px"
    eager
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        id="folder_picker__ubicacion_archivo__text"
        :value="folderPath"
        label="Ubicación del archivo"
        :prepend-icon="icon.folder"
        readonly
        v-bind="attrs"
        v-on="readonly ? null : on"
      ></v-text-field>
    </template>

    <div class="pa-0">
      <folder-tree
        dense
        searchable
        :value="value"
        @onChangeActionFolder="changeActionFolder"
      ></folder-tree>
    </div>
  </v-menu>
</template>

<script>
import FolderTree from '@/modules/catalogs/components/FolderTree'
import {
  folderStoreData,
  folderStoreActions
} from '@/modules/catalogs/store/folderStoreHelpers'
import { mdiFolderOutline } from '@mdi/js'

export default {
  name: 'FolderPicker',
  props: {
    value: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FolderTree
  },
  data() {
    return {
      icon: {
        folder: mdiFolderOutline
      },
      menuTree: false,
      folderPath: '',
      folderActive: null
    }
  },
  computed: {
    ...folderStoreData
  },
  methods: {
    ...folderStoreActions,
    changeActionFolder(node) {
      this.folderPath = node.ruta.join('/')
      this.folderActive = node
      this.menuTree = false
      this.$emit('input', node.idCarpeta)
      this.$emit('change', node)
    }
  }
}
</script>
